import { render, staticRenderFns } from "./ReturnDetail.vue?vue&type=template&id=5738fd8c&scoped=true"
import script from "./ReturnDetail.vue?vue&type=script&lang=js"
export * from "./ReturnDetail.vue?vue&type=script&lang=js"
import style0 from "./ReturnDetail.vue?vue&type=style&index=0&id=5738fd8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5738fd8c",
  null
  
)

export default component.exports